import { render, staticRenderFns } from "./MyAccountTabContent.vue?vue&type=template&id=5abc2b59&scoped=true&"
import script from "./MyAccountTabContent.vue?vue&type=script&lang=js&"
export * from "./MyAccountTabContent.vue?vue&type=script&lang=js&"
import style0 from "./MyAccountTabContent.vue?vue&type=style&index=0&id=5abc2b59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abc2b59",
  null
  
)

export default component.exports